import { createSlice } from '@reduxjs/toolkit';

export const wizardSlice = createSlice({
  name: 'wizard',
  initialState: {
    data: null,
    isLoading: false,
    error: null,
    dataSkip: null,
    isLoadingSkip: false,
    errorSkip: null,
  },
  reducers: {
    wizardRequest: (state) => {
      state.isLoading = true;
    },
    wizardSuccess: (state, action) => {
      state.data = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    wizardError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    wizardSkipRequest: (state) => {
      state.isLoadingSkip = true;
    },
    wizardSkipSuccess: (state, action) => {
      state.dataSkip = action.payload;
      state.errorSkip = null;
      state.isLoadingSkip = false;
    },
    wizardSkipError: (state, action) => {
      state.errorSkip = action.payload;
      state.isLoadingSkip = false;
    },
  },
});

export const { wizardRequest, wizardSuccess, wizardError, wizardSkipRequest, wizardSkipSuccess, wizardSkipError } = wizardSlice.actions;

export const selectWizardData = (state) => state.wizard.data;
export const selectWizardLoading = (state) => state.wizard.isLoading;
export const selectWizardError = (state) => state.wizard.error;
export const selectWizardSkipData = (state) => state.wizard.dataSkip;
export const selectWizardSkipLoading = (state) => state.wizard.isLoadingSkip;
export const selectWizardSkipError = (state) => state.wizard.errorSkip;

export default wizardSlice.reducer;
